export const replaceObjectInlineInArray = <T extends { id: string }>(array: T[] | undefined, replacementObject: T) => {
  if (!array) return []
  const existingObjectIndex = array.findIndex((e) => e.id === replacementObject.id)
  if (existingObjectIndex === -1) return [replacementObject, ...array]
  return [...array.slice(0, existingObjectIndex), replacementObject, ...array.slice(existingObjectIndex + 1)]
}
